module.exports = __webpack_public_path__ + "static/media/ht.06eefed9.svg";